module.exports = __webpack_public_path__ + "static/img/code.c5f407cd.png";